// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"fb105699","453":"4b636e8e"}[chunkId] + ".chunk.js";
};